import { render, staticRenderFns } from "./CreateRequest.vue?vue&type=template&id=1caa94b0&scoped=true&"
import script from "./CreateRequest.vue?vue&type=script&lang=js&"
export * from "./CreateRequest.vue?vue&type=script&lang=js&"
import style0 from "./CreateRequest.vue?vue&type=style&index=0&id=1caa94b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1caa94b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1caa94b0')) {
      api.createRecord('1caa94b0', component.options)
    } else {
      api.reload('1caa94b0', component.options)
    }
    module.hot.accept("./CreateRequest.vue?vue&type=template&id=1caa94b0&scoped=true&", function () {
      api.rerender('1caa94b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/shared/updowngrade/CreateRequest.vue"
export default component.exports